<template>
    <div class="de-text-rank-wrapper">
        <div class="rank-top-header">
            <span class="province">{{name}}</span>
            <span class="rank">NO.{{rank}}</span>
        </div>
        <div class="rank-top-content">
            <span class="total">{{total}}</span>
            <span class="percent">{{percent}}%</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'de-text-rank-number-percent',
    props: {
        name: {
            type: String
        },
        rank: {
            type: String
        },
        total: {
            type: String
        },
        percent: {
            type: String
        }
    },
    data() {
        return {}
    }
}
</script>

<style lang="less" scoped>
.de-text-rank-wrapper{
    .rank-top-header{
        font-size: 16px;
        .province{
            color: rgba(255, 255, 255, .75);
        }
        .rank{
            color: #038cfb;
            margin-left: 10px;
            font-family: 'AgencyFB-Reg';
        }
    }
    .rank-top-content{
        margin-top: 10px;
        .total{
            font-size: 32px;
            color: #fff;
        }
        .percent{
            font-size: 18px;
            margin-left: 10px;
            color: #038cfb
        }
    }
}
</style>